import React, { Component } from "react";
import { Grid, Col, Row, Button, Modal, Image } from "react-bootstrap";
import Card from "../../../components/Card/Card";
import Loading from "../../../views/Loading";
import _ from "lodash";
// import { rutas } from "../../../routes_backend/routes";
// import moment from "moment";
import ReactTable from "react-table-6";
import { sociedades } from "../../../variables/constantes";
// import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';

import "react-table-6/react-table.css";
import "./style.css";
import Swal from 'sweetalert2';  // Importa SweetAlert2
import { dominio } from "../../../routes_backend/routes.jsx";




// const myGrid3 = React.createRef();
class Autorizaciones_compras extends Component {
  constructor(props) {
    super(props);
    this.state = {
      message: "",
      isLoading: false,
      listAutorizaciones: [],
      comments: "",
      status: 1,
      
      sociedad: sociedades,
      is_sociedad: "SBO_MACIZO",

      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",

      usrWisap: "",
      userWisapId: "",
      db_sociedad: "",
      url_autorizaciones: "",
      name_sociedad: "",
      id_sociedad: "",
    };
    this.onChange = this.onChange.bind(this);
    this.abrirModalAdjuntos = this.abrirModalAdjuntos.bind(this);
    this.abrirModalVistaPrevia = this.abrirModalVistaPrevia.bind(this);
    this.cerrarModalVistaPrevia = this.cerrarModalVistaPrevia.bind(this);
    this.cerrarModalAdjuntos = this.cerrarModalAdjuntos.bind(this);


  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleCloseEnable = () => {
    this.setState({ showModalconfirm: false });
  };
  componentWillMount(user, Iduser, sociedad) {
    let token = localStorage.getItem("token");
    if (token !== null) {
      let token_Data = JSON.parse(token);
      console.log(token_Data);
      
      // var user;
      // var Iduser;
      // var sociedad;


      token_Data.forEach((element) => {
        user = element.USER_CODE;
        Iduser = element.U_UserId;
        sociedad = element.db;
      });    
      
    }
    
   this.datosBD()
  }

  datosBD = () =>{
    
      this.get_list_autorizaciones();
  
  }

  get_list_autorizaciones = (user, sociedad) => {
    const { is_sociedad } = this.state;
  
    let username = '';
    let password = '';
    let codigoUser = '';
    const token = localStorage.getItem('token');
    const token_Data = JSON.parse(token);
  
    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
        codigoUser = element.U_UserId;
      });
    }
  
    if (token_Data === null) {
      this.props.history.push('');
    }
  
    this.setState({
      message: "",
      isLoading: true,
      listAutorizaciones: [],
      comments: "",
      status: 1,
      showModal: false,
      showModalconfirm: false,
      messageConfirm: "",
      responde_server: "",
    });
  
    fetch(`${dominio}/get_ListRequisiciones`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username,
        password,
        codigoUser,
        is_sociedad,
      }),
    })
      .then(async (res) => {
        if (res.status === 404) {
          const errorData = await res.json();
          this.setState({
            isLoading: false,
            message: errorData.error || "No hay autorizaciones pendientes con este usuario",
          });
          return;
        }
        const data = await res.json();
        this.setState({
          listAutorizaciones: data,
          isLoading: false,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          isLoading: false,
          message: 'No hay autorizaciones pendientes con este usuario',
        });
      });
  };
  



  autorizar = (data) => {
    this.setState({
      message: "",
      isLoading: true,
      messageConfirm: "",
    });
    var commentario;
    var status;
    if (data.Comments === undefined) {
      commentario = "";
    }
    if (data.Comments !== undefined) {
      commentario = data.Comments;
    }
    if (data.estatus === undefined) {
      status = "";
    }
    if (data.estatus !== undefined) {
      status = data.estatus;
    }
    if (status === "") {
      this.setState({
        message: "",
        isLoading: false,
        messageConfirm: "",
      });
    }
    if (status !== "") {

      console.log("WddCode: " + data.WddCode);
      console.log("commentario: " + commentario);
      console.log("status: " + status);
      
      
      var username = "";
      var password = "";
    
      let token = localStorage.getItem("token"); 
      let token_Data = JSON.parse(token); 
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;          
        });
      }
 
      
      if (token_Data === null) {
        this.props.history.push("");
      }

      var WddCode = data.WddCode;
      console.log(status);
      

     const response = fetch(`${dominio}/updateAutorizaciones`, {
       method: 'PATCH',
       headers: {
         'Content-Type': 'application/json',
       },
       body: JSON.stringify({ 
        WddCode,
        commentario,
        status,
         username,
         password,        
       }),
     });
   
     response
       .then((res) => res.json(), )
       .then((data) => {
        console.log(data);
 
         if (data.success) {

           // const tableDetails = JSON.parse(data[0]);
           Swal.fire({
            icon: 'success',
            title: 'Exito',
            text: 'Registro actualizado correctamente'
          })
          this.datosBD()
           this.setState({
            isLoading: false,
            message: "",
          });
           
           return;
           
           // console.log('TM Creado Exitosamente');          
          
         } else {
           console.error('Error en la solicitud:', data[0].message);

           const errorMessage = data[0].message;
          
           // Reemplaza el alert con SweetAlert2
           Swal.fire({
             icon: 'error',
             title: 'Error al actualizar usuario',
             text: errorMessage || 'Mensaje de error no disponible'
           })

         }
        })
        .catch((error) => {
          console.error('Error en la solicitud:', error);
 
          const errorMessage = error;
           
            // Reemplaza el alert con SweetAlert2
            Swal.fire({
              icon: 'error',
              title: 'Error en la solicitud',
              text: errorMessage || 'Mensaje de error no disponible'
            })
        });
      
     
    }
  };


  abrirModalAdjuntos = async (DocEntry, Adjunto) => {
    const { is_sociedad } = this.state;
    console.log(DocEntry);
    
  
    var username = '';
    var password = '';
    var codigoUser = '';
    let token = localStorage.getItem('token');
    let token_Data = JSON.parse(token);
  
    if (token_Data !== null) {
      token_Data.forEach((element) => {
        username = element.usuarioSAP;
        password = element.contraseñaSAP;
        codigoUser = element.U_UserId;
      });
    }
  
    if (token_Data === null) {
      this.props.history.push('');
    }
  
    this.setState({
      message: "",
      isLoading: true,
    });
  
    const response = fetch(`${dominio}/get_ListRequisicionesAdjuntos`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        username,
        password,
        codigoUser,
        is_sociedad,
        DocEntry
      }),
    });
  
    response
      .then(async (res) => {
        let data = await res.json();
        const adjuntoBase64 = data.length > 0 ? data[0].doc : null;
  
        this.setState({
          isLoading: false,
          isModalOpenAdjuntos: true,
          adjuntoBase64, // Guardamos el adjunto en base64
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isLoading: false,
        });
      });
  };
  


  ver_solicitud = (solicitud, type, codigoUser) => {
    const { is_sociedad } = this.state;

    console.log(is_sociedad);
    

    if (is_sociedad === 'SBO_MACIZO') {


      var username = '';
      var password = '';
      // var codigoUser = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);
  
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
          codigoUser = element.U_UserId;
        });
      }
  
      if (token_Data === null) {
        this.props.history.push('');
      }
      console.log(token_Data);
      
  
  
      this.setState({
        message: "",
        isLoading: true,
        // listAutorizaciones: [],
        comments: "",
        status: 1,
        showModal: false,
        showModalconfirm: false,
        messageConfirm: "",
        responde_server: "",
      });
  
      const response = fetch(`${dominio}/get_ListRequisicionesVistaPrevia`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          username,
          password,
          solicitud,
        }),
        });
  
  
      // let url = `${rutas.get_list_autorizaciones}/?user=${user}&sociedad=${is_sociedad} `;
      // console.log(url);
  
      response
      .then(async (res) => {
        let data = await res.json();
  
        console.log(data);
        
  
        this.setState({
          listAutorizacionesVistaPrevia: data,
          isLoading: false,
        });
      
    
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isLoading: false,
          message: 'No hay autorizaciones pendientes con este usuario'
        });
      });
    }
    if (this.state.id_sociedad === 2) {
      if (type === "I") {
        window.open(
          "http://190.56.9.2222:8012/DraftSI/vistaPrevia/" + solicitud
        );
      }
      if (type !== "I") {
        window.open(
          "http://190.56.9.2222:8012/DraftSI/vistaPreviaS/" + solicitud
        );
      }
    }
    if (this.state.id_sociedad === 3) {
      window.open("http://190.56.9.2222/DraftTra/vistaPrevia/" + solicitud);
    }
  };

  abrirModalVistaPrevia(solicitud, type, codigoUser) {
    const { is_sociedad } = this.state;

    console.log(is_sociedad);
    

    if (is_sociedad === 'SBO_MACIZO') {


      var username = '';
      var password = '';
      // var codigoUser = '';
      let token = localStorage.getItem('token');
      let token_Data = JSON.parse(token);
  
      if (token_Data !== null) {
        token_Data.forEach((element) => {
          username = element.usuarioSAP;
          password = element.contraseñaSAP;
          codigoUser = element.U_UserId;
        });
      }
  
      if (token_Data === null) {
        this.props.history.push('');
      }
      console.log(token_Data);
      
  
  
      this.setState({
        message: "",
        isLoading: true,
       
      });
  
      const response = fetch(`${dominio}/get_ListRequisicionesVistaPrevia`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          username,
          password,
          solicitud,
        }),
        });
  
  
      // let url = `${rutas.get_list_autorizaciones}/?user=${user}&sociedad=${is_sociedad} `;
      // console.log(url);
  
      response
      .then(async (res) => {
        let data = await res.json();
  
        console.log(data);
        
  
        this.setState({
          listAutorizacionesVistaPrevia: data,
          isLoading: false,
          isModalOpenVistaPrevia: true,

        });
      
    
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          isLoading: false,
          message: 'No hay autorizaciones pendientes con este usuario'
        });
      });
    }
    if (this.state.id_sociedad === 2) {
      if (type === "I") {
        window.open(
          "http://190.56.9.222:8012/DraftSI/vistaPrevia/" + solicitud
        );
      }
      if (type !== "I") {
        window.open(
          "http://190.56.9.222:8012/DraftSI/vistaPreviaS/" + solicitud
        );
      }
    }
    if (this.state.id_sociedad === 3) {
      window.open("http://190.56.9.222/DraftTra/vistaPrevia/" + solicitud);
    }


  }

  cerrarModalVistaPrevia() {
    this.setState({ isModalOpenVistaPrevia: false });
  }

  cerrarModalAdjuntos() {
    this.setState({ isModalOpenAdjuntos: false });
  }


  getComments = (index, Comments) => {
    let tabledata = [...this.state.listAutorizaciones];
    tabledata[index].Comments = Comments;
  };
  get_status = (index, estatus) => {
    let tabledata = [...this.state.listAutorizaciones];
    tabledata[index].estatus = estatus;
  };
  render() {
    const { listAutorizacionesVistaPrevia, isLoading, message, isModalOpenVistaPrevia, isModalOpenAdjuntos  } = this.state;

    const total = Array.isArray(listAutorizacionesVistaPrevia)
    ? listAutorizacionesVistaPrevia.reduce((acc, item) => acc + parseFloat(item.LineTotal), 0).toFixed(2)
    : '0.00';

    const formatDate = (dateString) => {
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('es-ES', options).format(date);
    };
  
    
    let data_status = [
      // { id: 1, text: "Pendiente" },
      // { id: 2, text: "Autorizado" },
      // { id: 3, text: "Rechazado" },
      { id: 'Pendiente', text: "ardPending" },
      { id: 'Autorizado', text: "ardApproved" },
      { id: 'Rechazado', text: "ardNotApproved" },

    ];
    let columns = [
      {
        Header: "solicitud",
        accessor: "DocEntry",
        Cell: (props) => (
          <Button
            bsStyle="info"
            bsSize="small"
            active
            onClick={() =>
              this.abrirModalVistaPrevia(props.row.DocEntry, props.original.DocType)
            }
          >
            {props.row.DocEntry}
          </Button>
        ),
      },
      {
        Header: "Adjunto",
        accessor: "Adjunto",
        Cell: (props) => (
          <Button
            bsStyle={props.original.Adjunto === 0 ? "default" : "danger"}
            bsSize="small"
            active
            disabled={parseInt(props.row.Adjunto) === 0 ? true : false}
            onClick={() =>
              this.abrirModalAdjuntos(props.row.DocEntry, props.row.Adjunto)
            }
          >
            Ver
          </Button>
        ),
      },
      {
        Header: "Documento",
        accessor: "WddCode",
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "ID Usuario",
        accessor: "OwnerID",
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "Solicitante",
        accessor: "U_NAME",
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "Fecha",
        accessor: "DocDate",
        Cell: (props) => <div>{props.row.DocDate.slice(0, -14)}</div>,
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "Hora",
        accessor: "CreateTime",
        getProps: (state, rowInfo, column) => {
          return {
            style: {
              fontSize: "12px",
            },
          };
        },
      },
      {
        Header: "Estado",
        accessor: "estatus",
        width: 150,
        Cell: (props) => (
          <select
            value={
              props.row._original.estatus !== undefined
                ? 1
                : props.row._original.estatus
            }
            name="id_status"
            id="id_status"
            className="form-control"
            onChange={(e) => this.get_status(props.index, e.target.value)}
          >
            {data_status &&
              data_status.map((res) => (
                <option key={res.id} value={res.text}>
                  {res.id}
                </option>
              ))}
          </select>
        ),
      },
      {
        Header: "Comentarios",
        accessor: "Comments",
        width: 250,
        Cell: (props) => (
          <textarea
            className="comments"
            maxLength="75"
            onChange={(e) => this.getComments(props.index, e.target.value)}
            type="text"
          />
        ),
      },
      {
        Header: "Autorizar",
        accessor: "CreateTime",
        Cell: (props) => (
          <Button
            bsStyle="primary"
            bsSize="small"
            active
            onClick={() => this.autorizar(props.row._original)}
          >
            Autorizar
          </Button>
        ),
      },
    ];
    return (
      
      <div
        className="content"
        style={{ textAlign: "center", alignItems: "center" }}
      >
        <Grid fluid>
          <Row>
            <Col md={12}>
            <div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpenVistaPrevia ? 'block' : 'none' }}>
  <div className=" modal-dialog-custom-width" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Vista Previa</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.cerrarModalVistaPrevia}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body" style={{ maxHeight: '500px', overflowY: 'auto' }}>
        {Array.isArray(listAutorizacionesVistaPrevia) && listAutorizacionesVistaPrevia.length > 0 && (
          <>
            <div>
              <strong>Solicitante:</strong> {listAutorizacionesVistaPrevia[0].U_NAME} &nbsp;&nbsp;&nbsp;
              <strong># Documento:</strong> {listAutorizacionesVistaPrevia[0].DraftEntry}
            </div>

            <table>
              <thead>
                <tr>
                  <th>Codigo</th>
                  <th>Descripcion</th>
                  <th>Precio con IVA</th>
                  <th>Almacen</th>
                  <th>Cantidad</th>
                  <th>Stock</th>
                  <th>Comprometido</th>
                  <th>Precio</th>
                  <th>Total</th>
                  
                </tr>
              </thead>
              <tbody>
                {listAutorizacionesVistaPrevia.map((item, index) => (
                  <tr key={index}>
                    <td>{item.ItemCode}</td>
                    <td>{item.Dscription}</td>
                    <td>{parseFloat(item.PriceAfVAT).toFixed(2)}</td>
                    <td>{item.WhsCode}</td>
                    <td>{item.Quantity}</td>
                    <td>{item.IsCommited}</td>
                    <td>{item.OnHand}</td>
                    <td>{parseFloat(item.Price).toFixed(2)}</td>            
                    <td>{parseFloat(item.LineTotal).toFixed(2)}</td>            
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="info-section">
              <div className="comments">
                <strong>Comentario:</strong> 
                &nbsp;
                {listAutorizacionesVistaPrevia[0].Comments}
              </div>
              <div className="total">
                <strong>Total:</strong> {total}
                <br />
                <strong>Total/IVA:</strong> {parseFloat(listAutorizacionesVistaPrevia[0].DocTotal).toFixed(2)}
              </div>
            </div>

            <div className="create-date">
            <strong>Fecha Creacion:</strong> {formatDate(listAutorizacionesVistaPrevia[0].CreateDate)}
            </div>
          </>
        )}
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={this.cerrarModalVistaPrevia}>
          Cerrar
        </button>
      </div>
    </div>
  </div>
          </div>

<div className="modal" tabIndex="-1" role="dialog" style={{ display: isModalOpenAdjuntos ? 'block' : 'none' }}>
  <div className="modal-dialog-custom-width" role="document">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Vista Previa</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.cerrarModalAdjuntos}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body" style={{ height: '700px' }}>
        {this.state.adjuntoBase64 ? (
          <iframe
            src={`data:application/pdf;base64,${this.state.adjuntoBase64}`}
            style={{ width: '100%', height: '100%' }}
            frameBorder="0"
          >
           </iframe> 
        ) : (
          <p>No hay adjunto para mostrar</p>
        )}
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={this.cerrarModalAdjuntos}>
          Cerrar
        </button>
      </div>
    </div>
  </div>
</div>


              <Card
                title="AUTORIZACIONES"
                category="AUTORIZACIONES"
                ctTableFullWidth
                ctTableResponsive
                content={

                  

                  <div className="content">
                    
                    <div className="row">
                      <div className="col-sm-12">
                         {/*<p style={style.message}>{message}</p>*/} 
                        <br />
                      </div>
                   
                        <p style={style.errorMessage}>{message}</p>
                      <br />
                      
                      <br />
                      &nbsp;
                     <br />
                      {!_.isEmpty(this.state.listAutorizaciones) ? (
                        <div className="col-sm-12">
                          <br />
                          <br />
                          <ReactTable
                            data={this.state.listAutorizaciones}
                            columns={columns}
                            defaultPageSize={
                              this.state.listAutorizaciones.length
                            }
                            filterable={true}
                            defaultFilterMethod={(filter, row, column) => {
                              const id = filter.pivotId || filter.id;
                              if (typeof filter.value === "object") {
                                return row[id] !== undefined
                                  ? filter.value.indexOf(row[id]) > -1
                                  : true;
                              } else {
                                return row[id] !== undefined
                                  ? String(row[id]).indexOf(filter.value) > -1
                                  : true;
                              }
                            }}
                          />
                        </div>
                      ) : (
                        
                        <p style={{ fontSize: "16px", fontWeight: "bold" }}>
                          <br /><br /><br />
                          {/* Seleccione Base de datos */}
                        </p>
                      )}
                    </div>
                    {this.state.isLoading === false
                      ? this.state.showModal && (
                          <Modal
                            show={this.state.showModalconfirm}
                            onHide={this.handleCloseEnable}
                            bsSize="sm"
                          >
                            <Modal.Header closeButton />
                            <Modal.Body>
                              <div>
                                <center>
                                  <strong>
                                    {this.state.responde_server === true
                                      ? "Datos Actualizados Exitosamente"
                                      : "¡Ha ocurido un error!"}
                                  </strong>
                                </center>
                                <br />
                                <center>
                                   <p style={style.message}>{message}</p> 
                                  <div>{this.state.messageConfirm}</div>
                                </center>
                                <br />
                                <center>
                                  {this.state.responde_server === true ? (
                                    <Image
                                      src={
                                        "https://us.123rf.com/450wm/photoart23d/photoart23d1902/photoart23d190201464/117662421-marcas-de-verificaci%C3%B3n-degradado-verde-icono-de-marca-dentro-del-c%C3%ADrculo-ilustraci%C3%B3n-vectorial.jpg?ver=6"
                                      }
                                      width={"25%"}
                                      height={"auto"}
                                    />
                                  ) : (
                                    <Image
                                      src={
                                        "https://us.123rf.com/450wm/arcady31/arcady311108/arcady31110800003/10101127-vector-attention-warning-sign.jpg?ver=6"
                                      }
                                      width={"30%"}
                                      height={"auto"}
                                    />
                                  )}
                                </center>
                              </div>
                            </Modal.Body>
                            <Modal.Footer>
                              <div style={{ float: "left" }}>
                                <Button
                                  onClick={this.handleCloseEnable}
                                  bsStyle="info"
                                  active
                                >
                                  Cerrar!
                                </Button>
                              </div>
                            </Modal.Footer>
                          </Modal>
                        )
                      : null}





                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {isLoading && <Loading />}
      </div>
    );
  }
}

export default Autorizaciones_compras;
const style = {
  message: {
    fontWeight: "bold",
    fontSize: "12px",
    height: "10px",
    color: "red",
  },
};
